import React, { PureComponent } from "react";
import { PieChart, Pie, Sector, Cell, ResponsiveContainer, Tooltip, Legend } from "recharts";

import numeral from "numeral";

import { colors } from "containers/Next/NextReducer";

import styles from "./style.module.css";

export default class QualityScanPieChart extends PureComponent {
  render() {
    const { data } = this.props;

    const totalTables = data.reduce(
      (a, b) => a + (b?.schema_monitor?.schema?.tables !== undefined ? b?.schema_monitor?.schema?.tables.length : 0),
      0
    );
    const totalDatasets = data.reduce((a, b) => a + b.dataset_count, 0);
    const fixedCount = data.reduce((a, b) => a + (b.fixed_count ?? b.fixed_dataset_count), 0);
    const badCount = data.reduce((a, b) => a + b.error_dataset_count, 0);

    const goodCount = totalDatasets - fixedCount - badCount;

    const colorOption = {
      GOOD: "#12BF92",
      BAD: "rgba(203, 58, 49, 1)",
      FIXED: "#8CEDB5",
      ["NOT SCANNED"]: "#EFECF6"
    };

    const retData = [
      {
        name: "GOOD",
        value: goodCount,
        color: "#12BF92"
      },
      {
        name: "BAD",
        value: badCount,
        color: "rgba(203, 58, 49, 1)"
      },
      {
        name: "FIXED",
        value: fixedCount,
        color: "#8CEDB5"
      }
      // TODO: This does not account for tables that were downloaded twice.
      // {
      //   name: "NOT SCANNED",
      //   value: Math.max(0, totalTables - totalDatasets),
      //   color: "#EFECF6",
      // },
    ];

    return (
      <div className={styles.overviewPieChart}>
        <div className={styles.overviewQualityScanHolder}>
          <div className={styles.overviewMidValueQuality}>
            <div className={styles.overviewMidTopNumber}>{totalDatasets}</div>
            <div className={styles.overviewMidBotText}>{"DATASETS"}</div>
          </div>
          <PieChart width={300} height={300}>
            <Pie
              data={retData}
              cx={150}
              cy={150}
              innerRadius={80}
              outerRadius={100}
              fill="#8884d8"
              paddingAngle={2}
              dataKey="value"
            >
              {retData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry?.color} />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </div>
        <div className={styles.pieLegendQuality}>
          {retData.map((d, index) => (
            <div className={styles.pieLegendItem} key={"pi_" + index}>
              <div className={styles.pieLegendIcon} style={{ background: d.color || "#EFECF6" }} />
              <div className={styles.pieLegendText}>{d.name}</div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}
